export interface IB2CEmailInfo {
    Exists?: boolean;
    Blocked?: boolean;
}

export const isB2CEmailExist = (info: IB2CEmailInfo | undefined | null): boolean => !!info?.Exists && !info?.Blocked;
